import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import Platform from "react-native-web/dist/exports/Platform";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
var leftMargin = 50 - 1;
export default function styleConstructor() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var calendarHeight = arguments.length > 1 ? arguments[1] : undefined;
  var style = {
    container: _objectSpread({
      flex: 1,
      backgroundColor: '#ffff'
    }, theme.container),
    contentStyle: _objectSpread({
      backgroundColor: '#ffff',
      height: calendarHeight + 10
    }, theme.contentStyle),
    header: _objectSpread({
      paddingHorizontal: 30,
      height: 50,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: '#E6E8F0',
      backgroundColor: '#F5F5F6',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'stretch'
    }, theme.header),
    headerTextContainer: {
      justifyContent: 'center'
    },
    headerText: _objectSpread({
      fontSize: 16
    }, theme.headerText),
    arrow: {
      width: 15,
      height: 15,
      resizeMode: 'contain'
    },
    arrowButton: _objectSpread({
      width: 50,
      alignItems: 'center',
      justifyContent: 'center'
    }, theme.arrowButton),
    event: _objectSpread({
      position: 'absolute',
      backgroundColor: '#F0F4FF',
      borderColor: '#DDE5FD',
      borderWidth: 1,
      paddingLeft: 4,
      minHeight: 25,
      flex: 1,
      opacity: 1,
      paddingTop: 5,
      paddingBottom: 0,
      flexDirection: 'column',
      alignItems: 'flex-start',
      overflow: 'hidden'
    }, theme.event),
    eventTitle: _objectSpread({
      color: '#615B73',
      fontWeight: '600',
      minHeight: 15
    }, theme.eventTitle),
    eventSummary: _objectSpread({
      color: '#615B73',
      fontSize: 12,
      flexWrap: 'wrap'
    }, theme.eventSummary),
    eventTimes: _objectSpread({
      marginTop: 3,
      fontSize: 10,
      fontWeight: 'bold',
      color: '#615B73',
      flexWrap: 'wrap'
    }, theme.eventTimes),
    line: _objectSpread({
      height: 1,
      position: 'absolute',
      left: leftMargin,
      backgroundColor: 'rgb(216,216,216)'
    }, theme.line),
    lineNow: _objectSpread({
      height: 1,
      position: 'absolute',
      left: leftMargin,
      backgroundColor: 'red'
    }, theme.lineNow),
    timeLabel: _objectSpread({
      position: 'absolute',
      left: 15,
      color: 'rgb(170,170,170)',
      fontSize: 10,
      fontFamily: Platform.OS === 'ios' ? 'Helvetica Neue' : 'Roboto',
      fontWeight: '500'
    }, theme.timeLabel)
  };
  return StyleSheet.create(style);
}

if (typeof styleConstructor !== 'undefined' && styleConstructor && styleConstructor === Object(styleConstructor) && Object.isExtensible(styleConstructor) && !styleConstructor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(styleConstructor, '__filemeta', {
    configurable: true,
    value: {
      name: "styleConstructor",
      filename: "node_modules/react-native-calendars/src/timeline/style.js"
    }
  });
}